<template>
	<div class="container">
		<triangle-image
			title="Dal produttore alla tua tavola"
		/>

		<div>
			<section class="content">

				<h2>Costruiamo insieme una filiera del cibo più sostenibile</h2>

				<p>Scegliamo i prodotti con grandissima <b>cura e passione</b>. Ci confrontiamo con i produttori per avere gli ingredienti più adatti ad ogni preparazione e sempre nel <b>rispetto della stagionalità</b>. Sempre il <b>contatto diretto con i produttori</b> ci consente di evitare giacenze inutili in magazzino e sugli scaffali: la merce arriva fresca, poco prima di essere spedita e <b>nelle giuste quantità</b> per ridurre lo spreco di cibo quasi allo zero.</p>

				<img
					class="img-chain"
					src="../../assets/img/supply-chain.png"
				>
			</section>

			<section>
				<div class="content">
					<h2>I nostri produttori di qualità</h2>

					<p>Passione ed eccellenza: selezioniamo per voi solo i migliori produttori seguendo i criteri di <b>genuinità, artigianalità e sostenibilità</b> e, dove possibile, preferendo ingredienti biologici e di origine italiana. Scoprite qui tutte <b>le loro storie</b>.</p>
				</div>

				<div class="container-supplier" v-if="suppliers">
					<template
						v-for='(supplier, index) in suppliers'
					>
						<div
							v-if="!idsNoShow.includes(supplier.id)"
							class="shadow-box"
							:key="index"
						>
							<div
								@click="selectSupplier(supplier)"
							>
								<figure>
									<img
										:src="supplier.images.big"
										:alt="supplier.title"
									>

									<div class="img-overlay">
										<span>Scopri di più</span>
									</div>
								</figure>

								<div class="member-info">
									<div class="title">
										{{ supplier.title }}
									</div>
									<div>
										{{ supplier.description_short }}
									</div>
								</div>
							</div>
						</div>
					</template>
				</div>
			</section>

			<section>
				<router-link :to="{ name: 'flow-subscribed' }" class="flex flex-center">
					<CTA
						:content="`Ordina ora`"
						isArrow
					/>
				</router-link>
			</section>

		</div>
	</div>
</template>

<script>

import TriangleImage from '../../components/TriangleImage'
import { SupplierApi } from '../../api/SupplierApi'

export default {
	components: {
		TriangleImage
	},

	data () {
		return {
			suppliers: null,
			idsNoShow: [3, 12, 18, 21, 24, 25]
		}
	},

	computed: {
		supplier () {
			if (this.selectedSupplierId === null) return null
			return this.suppliers.find(record => record.id === this.selectedSupplierId)
		}
	},

	methods: {
		selectSupplier (supplier) {
			if (!supplier) return
			this.$router.push({ name: 'supplier', params: { id: supplier.url, supplier: supplier } }) 
		}
	},

	mounted () {
		var sm = new SupplierApi()
		sm.all({})

		.then(response => {
			this.suppliers = response.body.data.resources
		})
	}
}

</script>

<style scoped>
section {
	padding-bottom: 30px;
}

h2 {
	text-align: center;
}
.triangle-image {
	background-image: url("../../assets/img/covers/farmer.jpg");
	background-position: center 40%;
}
.content {
	max-width: 800px;
}

.container-supplier {
	cursor: pointer;
	margin: 0 auto;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	max-width: 1200px;
}

.container-supplier a {
	color: var(--quomi-primary);
	text-decoration: none;
}

.img-chain {
	width: 100%;
	max-width: 500px;
	margin: 0 auto;
	display: block;
}

.shadow-box {
	height: auto;
}

.container-supplier > div {
	flex-basis: calc(100% / 3 - 20px);
	margin: 10px;
	-webkit-transition: all 0.3s;
	-moz-transition: all 0.3s;
	transition: all 0.3s;
}

@media (max-width: 1024px) {
    .container-supplier > div {
        flex-basis: calc(100% / 2 - 20px);
    }
}

@media (max-width: 600px) {
		section {
			padding-bottom: 50px;
		}
    .container-supplier > div {
        flex-basis: calc(100% / 1 - 20px);
    }
}

.container-supplier > div:hover {
	transition: all 0.3s;
}
.container-supplier > div:hover .img-overlay {
	opacity: 1;
}
.container-supplier figure {
	position: relative;
	max-height: 203px;
	overflow: hidden;
}
.container-supplier img {
	display: block;
	width: 100%;
	border-radius: 4px 4px 0 0;
	min-height: 200px;
}

.container-supplier .img-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	opacity: 0;
	border-radius: 4px 4px 0 0;
	-webkit-transition: opacity 0.3s;
	-moz-transition: opacity 0.3s;
	transition: all 0.3s;
}

.img-overlay span {
	font-size: 16px;
	font-weight: 500;
	color: #ffffff;
	position: absolute;
	left: 50%;
	top: 50%;
	bottom: auto;
	right: auto;
	-webkit-transform: translateX(-50%) translateY(-50%);
	-moz-transform: translateX(-50%) translateY(-50%);
	-ms-transform: translateX(-50%) translateY(-50%);
	-o-transform: translateX(-50%) translateY(-50%);
	transform: translateX(-50%) translateY(-50%);
}
.container-supplier .member-info {
	background: #ffffff;
	text-align: center;
	padding-bottom: 15px;
	border-radius: 0 0 4px 4px;
}

.container-supplier .member-info .title {
	font-size: 20px;
	font-weight: bold;
}
</style>
